var _excluded = ["icon", "className", "color", "children"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
import classNamesMaker from "classnames";
import { Tag } from "#library/components/Tag";
import styles from "./eventCardTopTag.module.css";
export var EventCardTopTag = function EventCardTopTag(props) {
  var icon = props.icon,
    className = props.className,
    color = props.color,
    children = props.children,
    restProps = _objectWithoutProperties(props, _excluded);
  var classNames = classNamesMaker(styles["jds-EventCardTopTag"], className);
  return /*#__PURE__*/React.createElement(Tag, _extends({
    icon: icon,
    color: color,
    size: "small",
    className: classNames
  }, restProps), children);
};